import camelCaseKeys from 'camelcase-keys'

import { retryRequest } from '@themenu/request'

const DEFAULT_METHOD = 'GET'

type ApiRequestMethod = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE'

type ApiRequestShape = <TReturn, TInput, THeader>(_: {
  method?: ApiRequestMethod
  path: string
  resourceName?: string
  body?: TInput
  shouldFormatResponsePayload?: boolean
  rawRequest?: boolean
  headers?: THeader
  version?: 'v0' | 'v1'
}) => Promise<TReturn>

type AuthorizedRequestApiWrapperShape = <TReturn, TInput, THeader>(
  method: ApiRequestMethod,
  path: string,
  resourceName?: string,
  body?: TInput,
  shouldFormatResponsePayload?: boolean,
  headers?: THeader,
  timeout?: number,
) => Promise<TReturn>

const retryRequestApiWrapper: (
  serviceUrl: string,
  rawRequest?: boolean,
  rawResponse?: boolean,
  encode?: boolean,
) => AuthorizedRequestApiWrapperShape =
  (serviceUrl, rawRequest, rawResponse, encode) =>
  async (method = 'POST', endpoint, resourceName, body, shouldFormatResponsePayload = true, headers) => {
    try {
      const requestData = await retryRequest({
        method,
        serviceUrl,
        body: body as Record<string, unknown>,
        headers: headers as Record<string, string>,
        endpoint,
        options: {
          rawResponse,
          rawRequest,
          encode,
        },
      })

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const data = requestData as any
      if (resourceName && data[resourceName] !== undefined) {
        return shouldFormatResponsePayload ? camelCaseKeys(data[resourceName], { deep: true }) : data[resourceName]
      }
      return shouldFormatResponsePayload ? camelCaseKeys(data, { deep: true }) : data
    } catch (error) {
      return Promise.reject(error)
    }
  }

export const requestCustomerApi: ApiRequestShape = ({ method = DEFAULT_METHOD, path, resourceName, body }) => {
  const requestApi = retryRequestApiWrapper(String(import.meta.env.VITE_CUSTOMER_API_ENDPOINT))
  return requestApi(method, path, resourceName, body)
}

export const requestInvitationApi: ApiRequestShape = ({ method = DEFAULT_METHOD, path, resourceName, body }) => {
  const requestApi = retryRequestApiWrapper(String(import.meta.env.VITE_INVITATIONS_API_ENDPOINT))
  return requestApi(method, path, resourceName, body)
}

export const requestDirectoryApi: ApiRequestShape = ({ method = DEFAULT_METHOD, path, resourceName, body }) => {
  const requestApi = retryRequestApiWrapper(String(import.meta.env.REACT_APP_AUTH_APP_URL))
  return requestApi(method, path, resourceName, body)
}
